import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions'; // Updated import + added httpsCallable
import { ConfirmationService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss']
})
export class UsersListComponent implements OnInit {

  public users: any[];
  public roles: string[] = ['user', 'editor', 'admin', 'super'];

  //@ViewChild('email') emailInput : ElementRef;
  public email: string = "";
  public creatingUser: boolean;

  constructor(private _messageService: MessageService,
              private functions: Functions, // Updated injected type
              private confirmationService: ConfirmationService ) {
    // if(!environment.production)
    // {
    //   this.firebaseFunctions.useFunctionsEmulator('http://localhost:5001');
    // }
  }

  ngOnInit(): void {
    const getUsersCallable = httpsCallable(this.functions, 'getUsers'); // Use imported httpsCallable
    getUsersCallable({}).then((response: any) => { // Changed .subscribe to .then
      let users = [...response.data];
      for(let user of users)
      {
        if(!user.role)
          user.role = 'user';
      }
      this.users = users;
    }).catch(error => { // Changed error callback to .catch
      console.error(error);
    });
  }

  public createUser(emailInput:String) : void
  {
    if(emailInput.length > 0) {
      this.creatingUser = true;
      const createUserCallable = httpsCallable(this.functions, 'createUser2'); // Use imported httpsCallable
      createUserCallable({ username: emailInput }).then((response: any) => { // Changed .subscribe to .then
        console.log(response);
        // Check response.data for success/message/password as HttpsCallableResult structure changed
        const resultData = response.data as { success: boolean; message?: string; password?: string; data?: any };
        if(!resultData.success)
        {
          console.error(resultData.message);
          this._messageService.add({severity:'error', summary:'Error', detail:resultData.message});
          this.creatingUser = false;
          return;
        }
        // Assuming the user data is now nested under resultData.data
        console.log(resultData.password);
        this.users.push(resultData.data); // Adjust based on actual function response structure
        this.email = '';
        this._messageService.add({sticky: true, severity:'info', summary:'Copy and send this temporary password to the user:', detail:resultData.password});
        this.creatingUser = false;
      }).catch(error => { // Changed error callback to .catch
        console.error(error);
        this.creatingUser = false;
      });
    }
  }

  public deleteUser(uid: string, event: any) : void
  {
    var user = this.users.find(x=> x.uid === uid);
    if(user.role === 'admin' || user.role === 'super')
    {
      let adminCount = this.users.filter(x=> (x.role === 'admin' || x.role === 'super')).length;
      if(adminCount === 1)
      {
        this._messageService.add({severity:'error', summary:'Admin Required', detail:'You cannot delete last admin in the project.'});
        return;
      }
    }

    console.log(uid);
    this.confirm('Are you sure you want to delete this user?', event.currentTarget, () => {
      const deleteUserCallable = httpsCallable(this.functions, 'deleteUser'); // Use imported httpsCallable
      deleteUserCallable({ uid: uid }).then((response: any) => { // Changed .subscribe to .then
        // Check response.data for success/message as HttpsCallableResult structure changed
        const resultData = response.data as { success: boolean; message?: string };
        if(!resultData.success)
        {
          console.error(resultData.message);
          return;
        }
        // this.users.find(({ uid }) => uid === uid); // This line doesn't do anything useful
        let index = this.users.findIndex(item => item.uid === uid);
        if (index > -1) { // Ensure index is found before splicing
          this.users.splice(index,1);
        }
      }).catch(error => { // Changed error callback to .catch
        console.error(error);
      });
    });
  }

  public resetPassword(user, element) {
    this.confirm(`Are you sure you want to change this user's password?`, element, () => {
      let request = { 
        uid: user.uid
      }
      const resetPasswordCallable = httpsCallable(this.functions, 'resetPassword'); // Use imported httpsCallable
      resetPasswordCallable(request).then((response: any) => { // Changed .subscribe to .then
        // Check response.data for success/message/data as HttpsCallableResult structure changed
        const resultData = response.data as { success: boolean; message?: string; data?: any };
        if(!resultData.success)
        {
          console.error(resultData.message);
          return;
        }
        console.log(resultData.data);
        this._messageService.add({sticky: true, severity:'info', summary:'Copy and send this temporary password to the user:', detail:resultData.data});
      }).catch(error => { // Changed error callback to .catch
        console.error(error);
      });
    });
  }

  public setRole(user:any, dropdown:any, event:any) : void
  {
    if(user.role === 'admin' || user.role === 'super')
    {
      let adminCount = this.users.filter(x=> (x.role === 'admin' || x.role === 'super')).length;
      if(adminCount === 1)
      {
        this._messageService.add({severity:'error', summary:'Admin Required', detail:'You must have at least one admin in the project.'});
        return;
      }
    }

    this.confirm(`Are you sure you want to change this user role to ${event.value}?`, dropdown.el.nativeElement, () => {
      let request = { 
        role: event.value,
        uid: user.uid 
      }
      console.log(JSON.stringify(user));
      const setRoleCallable = httpsCallable(this.functions, 'setRole'); // Use imported httpsCallable
      setRoleCallable(request).then((response: any) => { // Changed .subscribe to .then
        // Check response.data for success/message as HttpsCallableResult structure changed
        const resultData = response.data as { success: boolean; message?: string };
        if(!resultData.success)
        {
          console.error(resultData.message);
          return;
        }
        user.role = event.value;
      }).catch(error => { // Changed error callback to .catch
        console.error(error);
      });
    });
  }

  private confirm(message: string, target: any, accept:()=> any) {
    this.confirmationService.confirm({
        target: target,
        message: message,
        icon: 'pi pi-exclamation-triangle',
        accept: () => accept()
    });
  }

}
